import styled from '@emotion/styled';

import { IThemeProps } from '@/styles/themes/types';

export const StyledImage = styled.img<IThemeProps>`
  width: 100%;
  margin: 0;
`;
